module.exports = __webpack_public_path__ + "static/media/1001.d997ac1c.jpg";